import React from 'react'
import { Container } from './styles'

const StatusPagarme = ({ status }) => {

  const getStatus = (status) => {
    const types = {
      paid: {
        color: '#069E12',
        text: 'Pago'
      },
      pending: {
        color: '#F8EF23',
        text: 'Pendente'
      },
      failed: {
        color: '#DD0000',
        text: 'Falha'
      },
      canceled: {
        color: '#96989A',
        text: 'Cancelado'
      },
      active: {
        color: '#069E12',
        text: 'Ativo'
      }
      
    }
    return types[status] || status
  }

  return (
    <Container color={getStatus(status)?.color} >
      {getStatus(status)?.text || status}
    </Container>
  )
}

export default StatusPagarme;
